import { Text, useTheme } from '@chakra-ui/react';

import { SUGGESTED_SERVICES_GROUP_TITLE } from 'utils/helpers/suggestedServices';

interface SuggestedServiceGroupHeaderProps {
  title?: string;
  isSubHeader?: boolean;
}

const SuggestedServiceGroupHeader = ({
  title = SUGGESTED_SERVICES_GROUP_TITLE,
  isSubHeader = false
}: SuggestedServiceGroupHeaderProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepService: {
            providerList: { providerHeader },
            serviceList: { serviceItem }
          }
        }
      }
    }
  } = useTheme();

  if (isSubHeader) {
    return (
      <Text
        fontSize={{ base: '15px', md: '16px' }}
        fontWeight='400'
        color={serviceItem.textColor}
        lineHeight='140%'
      >
        {title}
      </Text>
    );
  }

  return (
    <Text
      fontSize={{ base: '18px', md: '22px', lg: '25px' }}
      fontWeight='400'
      color={providerHeader.textColor}
      lineHeight='140%'
    >
      {title}
    </Text>
  );
};

export default SuggestedServiceGroupHeader;
